import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useSubCategoriesDocumentDetails } from "./Hooks/HighLight";
import { useLocalStorage } from "~/Hooks/useLocalStorage";

const AddEditHighlight = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [currentAirport] = useLocalStorage("currentAirport", null);

  const {
    data: editSubCategories,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchSubCategories,
  } = useSubCategoriesDocumentDetails(query.get("editId") || "");

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchSubCategories();
    }
  }, [query.get("editId"), query.get("id")]);

  // const epcApplicationsFormConfig: FormConfig = {
  //   initialValues: {
  //     name: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.name)
  //       : decodeHTML(editSubCategories?.name),
  //     field_malay_title: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.field_malay_title)
  //       : decodeHTML(editSubCategories?.field_malay_title),
  //     field_mandarin_title: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.field_mandarin_title)
  //       : decodeHTML(editSubCategories?.field_mandarin_title),
  //     field_category_id: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.field_category_id)
  //       : decodeHTML(editSubCategories?.field_category_id),
  //     // field_sub_order_seq: editSubCategoriesById?.payload
  //     //   ? decodeHTML(editSubCategoriesById?.payload?.field_sub_order_seq)
  //     //   : decodeHTML(editSubCategories?.field_sub_order_seq),
  //     field_sub_published: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.field_sub_published)
  //       : decodeHTML(editSubCategories?.field_sub_published),
  //   },
  //   fields: fields.sliders,
  // };
  const epcApplicationsFormConfig: FormConfig = {
    initialValues: {
      title: decodeHTML(editSubCategoriesById?.payload?.title) || decodeHTML(editSubCategories?.title) || "",
      airports: (decodeHTML(editSubCategoriesById?.payload?.airports) || decodeHTML(editSubCategories?.airports) || "")
        .split(",")
        .map((a: any) => a.trim())
        .filter(Boolean),
      body: decodeHTML(editSubCategoriesById?.payload?.body) || decodeHTML(editSubCategories?.body) || "",
      link: decodeHTML(editSubCategoriesById?.payload?.link) || decodeHTML(editSubCategories?.link) || "",
      sequence: decodeHTML(editSubCategoriesById?.payload?.sequence) || decodeHTML(editSubCategories?.sequence),
      published: editSubCategoriesById?.payload?.published ?? editSubCategories?.published ?? false,
      description:
        decodeHTML(editSubCategoriesById?.payload?.description) || decodeHTML(editSubCategories?.description) || "",
      banner: editSubCategoriesById?.payload
        ? [
            {
              uid: "-1",
              name: "banner.jpg",
              status: "done",
              url: decodeHTML(editSubCategoriesById?.payload?.banner),
            },
          ]
        : editSubCategories
          ? [
              {
                uid: "-1",
                name: "banner.jpg",
                status: "done",
                url: decodeHTML(editSubCategories?.banner),
              },
            ]
          : "",
    },

    fields: fields.highlight,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("highlight", data);
    let imageKeys: any = ["banner"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    if (Array.isArray(data.airports)) {
      data.airports = data.airports.join(", ");
    }

    const payload = {
      action: action,
      method: method,
      module: "Home Page",
      subModule: "highlight",
      airportName: currentAirport,
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editSubCategories?.id || editSubCategoriesById?.payload?.id }),
        ...data,
        // field_sub_categories_status: true,
        // field_sub_created_at: "2023-11-21T10:01:09",
        // field_sub_updated_at: "2025-11-29T10:01:09"
      },
      status: status,
    };

    // console.log(payload, "tested");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingSubCategories}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Highlight`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingSubCategories || drilldownLoading}
        config={epcApplicationsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${passengerHost}/api/spotlight/section-three/${editSubCategories?.id || editSubCategoriesById?.payload?.id}` : `${passengerHost}/api/spotlight/section-three/new`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Homepage"
      />
    </ContentWrapper>
  );
};

export default AddEditHighlight;
